<template>
    <div>
        <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition"
            v-model="snackbar" timeout="2000" :value="true" :color="snaclr">
            <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
            {{ snackmsgbar }}
        </v-snackbar>

        <div class="ml-14 mr-14 mt-5">
            <v-card elevation="0" class=" pa-1">
                <v-toolbar dense class="elevation-0  ">
                    <v-toolbar-title>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold title">SIP
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <div class="mt-4" v-if="histtab == 0">
                        <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition"
                            min-width="auto" class="mt-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field flat solo background-color="#F1F3F8" v-model="dateRangeText"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" class="rounded-pill" dense
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dates" range @input="closeMenu"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="ml-3" v-if="histtab == 0">
                        <v-text-field dense v-model="tabledata" hide-details prepend-inner-icon="mdi-magnify"
                            style="max-width: 180px"></v-text-field>
                    </div>
                    <div class="ml-3" v-if="histtab == 0">
                        <v-btn @click="unpledgeregdown()" icon><v-icon>mdi-download</v-icon></v-btn>
                    </div>
                    <div class="ml-3" v-if="histtab == 0">
                        <v-btn :loading="tableload" @click="lumsunresdata()" icon><v-icon>mdi-refresh</v-icon></v-btn>
                    </div>

                    <div class="mt-4" v-if="histtab == 1">
                        <v-menu v-model="menutb1" :close-on-content-click="false" transition="scale-transition"
                            min-width="auto" class="mt-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field flat solo background-color="#F1F3F8" v-model="dateRangeTexttb1"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" class="rounded-pill" dense
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="datestb1" range @input="closeMenutb1"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="ml-3" v-if="histtab == 1">
                        <v-text-field dense v-model="tabledataall" hide-details prepend-inner-icon="mdi-magnify"
                            style="max-width: 180px"></v-text-field>
                    </div>
                    <div class="ml-3" v-if="histtab == 1">
                        <v-btn @click="unpledgeregdownall()" icon><v-icon>mdi-download</v-icon></v-btn>
                    </div>

                    <div class="ml-3" v-if="histtab == 1">
                        <v-btn :loading="tableloadall" @click="allordersdata()"
                            icon><v-icon>mdi-refresh</v-icon></v-btn>
                    </div>


                    <div class="mt-4" v-if="histtab == 3">
                        <v-menu v-model="menutb3" :close-on-content-click="false" transition="scale-transition"
                            min-width="auto" class="mt-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field flat solo background-color="#F1F3F8" v-model="dateRangeTexttb3"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" class="rounded-pill" dense
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="datestb3" range @input="redustadate"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="ml-3" v-if="histtab == 3">
                        <v-text-field dense v-model="redmsatse" hide-details prepend-inner-icon="mdi-magnify"
                            style="max-width: 180px"></v-text-field>
                    </div>
                    <div class="ml-3" v-if="histtab == 3">
                        <v-btn v-if="redumstadata.filepath != ''" @click="downloadFilesat()"
                            icon><v-icon>mdi-download</v-icon></v-btn>
                    </div>

                    <div class="ml-3" v-if="histtab == 3">
                        <v-btn :loading="tableloadall" @click="redmenstatment()"
                            icon><v-icon>mdi-refresh</v-icon></v-btn>
                    </div>

                    <div class="mt-4" v-if="histtab == 7">
                        <v-menu v-model="menutb1" :close-on-content-click="false" transition="scale-transition"
                            min-width="auto" class="mt-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field flat solo background-color="#F1F3F8" v-model="dateRangeTexttb1"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" class="rounded-pill" dense
                                    v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="datestb1" range @input="closeMenutb1"></v-date-picker>
                        </v-menu>
                    </div>


                    <div class="ml-3" v-if="histtab == 7">
                        <v-btn @click="unpledgeregdownall()" icon><v-icon>mdi-download</v-icon></v-btn>
                    </div>

                    <div class="ml-3" v-if="histtab == 7">
                        <v-btn :loading="tableloadall" @click="allordersdata()"
                            icon><v-icon>mdi-refresh</v-icon></v-btn>
                    </div>

                </v-toolbar>
                <v-divider></v-divider>
                <!-- <v-tabs v-model="histtab" color="black">

                    <v-tab class="text-capitalize">Daily Orders</v-tab>

                    <v-tab class="text-capitalize">All Orders</v-tab>
                    <v-tab class="text-capitalize">Mandate Details</v-tab>
                    <v-tab class="text-capitalize">Redemption Request</v-tab>
                    <v-tab class="text-capitalize">MF - Order </v-tab>
                    <v-tab class="text-capitalize"> SIP </v-tab>
                    <v-tab class="text-capitalize"> Holdings </v-tab>
                    

                    <v-tab class="text-capitalize" v-if="siporbookrest == 'sipbook'"> SIP OrderBook </v-tab>




                </v-tabs> -->
                <v-card outlined elevation="0" class="pa-4">
                            <!-- Fixed Section -->
                            <div class="d-flex align-center mb-4"
                                style="position: sticky; top: 0; background: white; z-index: 1;">
                                <div> <v-text-field prepend-inner-icon="mdi-account-multiple-outline"
                                        oninput="this.value = this.value.toUpperCase()" :readonly="sipvalread"
                                        hide-details class="mt-5 ml-5 rounded-pill" background-color="#F1F3F8" flat solo
                                        v-model="sipclient" style="width: 380px;" dense label="Client Id"
                                        type="text"></v-text-field>
                                </div>
                                <v-btn @click="sipchekfun()" :disabled="sipclient.length < 2 || sipvalread"
                                    :loading="sipcliload" rounded elevation="0" class="text-none mt-5 ml-5 mr-5"
                                    color="primary">
                                    Check
                                </v-btn>

                                <v-btn @click="clearsipdata()" :disabled="sipclient.length == ''" rounded outlined
                                    elevation="0" class="text-none mt-5" color="black">
                                    Clear
                                </v-btn>
                            </div>
<!-- <p>1111111111111</p> -->
                            <v-data-table mobile-breakpoint :search="sipsearchlist" height="50vh" fixed-header
                                :items-per-page="100" style="border: 1px solid #F1F3F8;" :headers="headersiplist"
                                :items="sipdataclilist" class="elevation-0 mt-5" disable-sort outlined>

                            

                                 <template v-slot:[`item.cancelord`]="{ item }">
                                    <v-btn rounded :loading="cancelstload" class="text-none" @click="oderdeletedet(item)" dense
                                        elevation="0" outlined v-if="item.status === 'ACTIVE'">Cancel SIP</v-btn>
                                </template>
                                  <template v-slot:[`item.pausesip`]="{ item }">
                                    <v-btn rounded :loading="cancelstload" class="text-none" @click="sippauseconfir(item)" dense
                                        elevation="0" outlined v-if="item.status === 'ACTIVE'">Pause SIP</v-btn>
                                </template>


                            </v-data-table>


                        </v-card>
                 
                <v-divider></v-divider>


                 <v-dialog v-model="pauseconfirdia" persistent max-width="490">

                                <v-card class="pa-5 rounded-lg">
                                    <p class="title font-weight-bold">
                                        Are You sure you want Pause this SIP order ?
                                        <!-- {{ calceldiadet }} -->
                                    </p>
                                    <p class="subtitle-1 font-weight-semibold"> clientcode : {{ pausesipdet.ClientCode
                                        }}</p>
                                    <p class="subtitle-1 font-weight-semibold"> schemename : {{ pausesipdet.name
                                        }}</p>
                                    <p class="subtitle-1 font-weight-semibold"> sipregnno : {{ pausesipdet.SIPRegnNo }}
                                    </p>

                                    <p class=" font-weight-bold"> Select no of installments pause the sip *
                                    </p>
                                    <!-- {{ cancelresonlist }} {{ cancelresfd }} -->
                                    <v-select placeholder="pause installments
                                    " dense item-value="id" :items="['1','2','3',
                                        '4','5','6','7','8','9','10'
                                    ]"
                                        outlined v-model="pausesipinst"></v-select>
                                 


                                    <!-- <v-spacer></v-spacer> -->
                                    <v-row>
                                        <v-col>
                                            <v-btn block color="black mr-14 darken-1 text-none px-14" rounded outlined
                                                @click="pauseconfirdia = false">
                                                close
                                            </v-btn>
                                        </v-col>
                                        <v-col>
                                            <v-btn :disabled="pausesipinst == ''" block color="black darken-1 ml-10 text-none px-14"
                                                :loading="finalloadcan" @click="pausesipapicall()" rounded outlined>
                                                Continue
                                            </v-btn>
                                        </v-col>
                                    </v-row>


                                </v-card>
                            </v-dialog>
          <v-dialog v-model="dialogcancel" persistent max-width="490">

                                <v-card class="pa-5 rounded-lg">
                                    <p class="title font-weight-bold">
                                        Are You sure you want cancel this order ?
                                    </p>
                                    <p class="subtitle-1 font-weight-semibold"> clientcode : {{ calceldiadet.ClientCode
                                    }}</p>
                                    <p class="subtitle-1 font-weight-semibold"> schemename : {{ calceldiadet.name
                                    }}</p>
                                    <p class="subtitle-1 font-weight-semibold"> sipregnno : {{ calceldiadet.SIPRegnNo }}
                                    </p>

                                    <p class="caption font-weight-bold"> Reject reson *
                                    </p>
                                    <!-- {{ cancelresonlist }} {{ cancelresfd }} -->
                                    <v-select placeholder="Reject reson" dense item-value="id" :items="cancelresonlist"
                                        item-text="reason_name" outlined v-model="cancelresfd"></v-select>
                                    <p v-if="cancelresfd == '13'" class="caption font-weight-bold"> Enter
                                        the Reason *
                                    </p>
                                    <v-text-field dense placeholeder="Enter the Reason" outlined v-model="canmanreason"
                                        v-if="cancelresfd == '13'"></v-text-field>


                                    <!-- <v-spacer></v-spacer> -->
                                    <v-row>
                                        <v-col>
                                            <v-btn block color="black mr-14 darken-1 text-none px-14" rounded outlined
                                                @click="dialogcancel = false">
                                                close
                                            </v-btn>
                                        </v-col>
                                        <v-col>
                                            <v-btn :disabled="cancelresfd == ''" block color="black darken-1 ml-10 text-none px-14"
                                                :loading="finalloadcan" @click="cancelapucall()" rounded outlined>
                                                Continue
                                            </v-btn>
                                        </v-col>
                                    </v-row>


                                </v-card>
                            </v-dialog>

                            <v-dialog v-model="dialogredcancel" persistent max-width="400">

                                <v-card class="pa-5 rounded-lg">
                                    <p class="title font-weight-bold">
                                        Are You Sure you Want to cancel Your Order ?
                                    </p>
                                    <p class="font-weight-semibold">clientcode : {{ candiashowdata.clientcode ?
                                        candiashowdata.clientcode : "" }}</p>
                                    <p class="font-weight-semibold">schemename : {{ candiashowdata.schemename ?
                                        candiashowdata.schemename : "" }}</p>
                                    <p class="font-weight-semibold">ordernumber : {{ candiashowdata.ordernumber ?
                                        candiashowdata.ordernumber : "" }}</p>


                                    <v-row>
                                        <v-col cols="6">
                                            <v-btn block color="black " rounded outlined small
                                                @click="dialogredcancel = false">
                                                close
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-btn block color="black " rounded :loading="canredload" outlined small
                                                @click="redcancelapi()">
                                                Continue
                                            </v-btn>
                                        </v-col>
                                    </v-row>


                                </v-card>
                            </v-dialog>
                <v-dialog persistent v-model="createmat" transition="dialog-bottom-transition" max-width="600">
                    <v-card class="pb-5 overflow-hidden" color="cardbg">
                        <v-card class="elevation-0 pa-4" color="#F1F3F8">
                            <div class="d-flex">
                                <p class="font-weight-bold fs-16 maintext--text mb-0">
                                    Create mandate
                                </p>
                            </div>
                        </v-card>

                        <div class="pa-4">
                            <p class="font-weight-regular fs-14 subtext--text mb-2">Amount *</p>
                            <v-text-field :readonly="orderpoploader" height="40px" background-color="#F1F3F8" flat
                                class="rounded-pill mb-4" solo type="number" hide-details hide-spin-buttons
                                @keyup="creatManmfamt ? (creatManmfamt = Number(creatManmfamt)) : creatManmfamt >= 100 ? mf_initial_amt : 100"
                                :min="100" :step="1000" v-model="creatManmfamt">
                                <template #append>
                                    <v-card @click="creatManmfamt += 1000"
                                        class="font-weight-bold subtitle-2 primary--text elevation-0 crd-trn">
                                        +
                                        {{ 1000 }}
                                    </v-card>
                                </template>

                                <template #prepend-inner>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none">
                                        <path
                                            d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                                            fill="white" />
                                        <path
                                            d="M15.4285 9.25426L15.0805 10.4574H8.58762L8.93066 9.25426H15.4285ZM12.3014 17L8.71689 12.6399L8.70197 11.7102H10.4818C10.9326 11.7102 11.3137 11.6423 11.6253 11.5064C11.9401 11.3705 12.1788 11.1716 12.3412 10.9098C12.5069 10.648 12.5898 10.3232 12.5898 9.93537C12.5898 9.36198 12.4191 8.90956 12.0777 8.57812C11.7363 8.24337 11.2043 8.07599 10.4818 8.07599H8.58762L8.94061 6.81818H10.4818C11.3005 6.81818 11.9733 6.95076 12.5003 7.21591C13.0306 7.47775 13.425 7.84067 13.6835 8.30469C13.942 8.7687 14.0713 9.29901 14.0713 9.8956C14.0713 10.4325 13.9603 10.9214 13.7382 11.3622C13.5194 11.7997 13.1698 12.156 12.6892 12.4311C12.2086 12.7029 11.5756 12.8537 10.79 12.8835L10.7453 12.8935L14.0365 16.9155V17H12.3014ZM15.4285 6.81818L15.0805 8.03125L9.91504 7.99645L10.2631 6.81818H15.4285Z"
                                            fill="#999999" />
                                    </svg>
                                </template>
                            </v-text-field>

                            <v-row no-glutters class="pb-4">
                                <v-col cols="6">
                                    <p class="font-weight-regular fs-14 subtext--text mb-2">Start date *</p>

                                    <v-menu v-model="creatManmffrommenu" :close-on-content-click="false"
                                        transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field background-color="#F1F3F8" flat class="rounded-pill" solo
                                                hide-details v-model="creatManmffrom" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker :readonly="orderpoploader"
                                            :min="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 2).toISOString().slice(0, 10)"
                                            v-model="creatManmffrommodel" no-title
                                            @input="(creatManmffrommenu = false), (creatManmftomodel = new Date(new Date().getFullYear() + 30, new Date(creatManmffrommodel).getMonth(), new Date().getDate()).toISOString().slice(0, 10))"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="6">
                                    <p class="font-weight-regular fs-14 subtext--text mb-2">End date *</p>
                                    <v-menu v-model="creatManmftomenu" :close-on-content-click="false"
                                        transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field background-color="#F1F3F8" flat class="rounded-pill" solo
                                                hide-details v-model="creatManmfto" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker :readonly="orderpoploader"
                                            :min="creatManmffrommodel ? new Date(new Date().getFullYear(), new Date(creatManmffrommodel).getMonth() + 2, new Date().getDate()).toISOString().slice(0, 10) : new Date()"
                                            v-model="creatManmftomodel" no-title
                                            @input="creatManmftomenu = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>

                            <p class="font-weight-bold fs-14 mb-2">Remarks</p>
                            <v-text-field background-color="#F1F3F8" v-model="alertremarks" flat class="rounded-pill"
                                solo dense type="text"> </v-text-field>
                        </div>

                        <div class="mx-4">
                            <v-row>
                                <v-col cols="6">
                                    <v-btn block @click="createmat = false" color="#F1F3F8" :disabled="orderloader"
                                        class="text-none rounded-pill elevation-0 subtext--text px-6" height="40px">
                                        Cancel </v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn @click="createmandaute()" color="black" :loading="orderloader"
                                        :disabled="orderloader" block
                                        class="text-none rounded-pill elevation-0 white--text subtext--text px-6"
                                        height="40px"> Submit
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>



                    </v-card>
                </v-dialog>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </v-card>
        </div>
    </div>
</template>


<script>
const today = new Date().toISOString().split("T")[0];

import exportFromJSON from "export-from-json";
// import MffoterOder from '../views/MFAdminOrder.vue'
// import { readonly } from "vue";

export default {
    components: {
        // MffoterOder,

    },
    data() {
        return {
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            dates: [today, today],
            datestb1: [today, today],
            datestb3: [today, today],

            menutb1: false,
            menutb3: false,
            modal: false,
            menu2: false,
            tabledata: "",
            headers: [
                {
                    text: 'Date & Time',
                    align: 'start',
                    value: 'date_time',
                },

                { text: 'order placed by', value: 'order_placed_by' },
                { text: 'Client Id', value: 'clientcode' },
                { text: 'Order /XSIP Number', value: 'order_number' },
                { text: 'ISIN', value: 'isin' },

                { text: 'Fund Name', value: 'scheme_name' },
                { text: 'Buy/Sell', value: 'buysell_type' },

                { text: 'Order Type', value: 'order_type' },
                { text: 'Amount', value: 'inv_lump_amt' },

                { text: 'Status', value: 'local_status' },
                // { text: '', value: 'staaction' },

            ],
            headersnewww: [
                {
                    text: 'Date & Time',
                    align: 'start',
                    value: 'date_time',
                },

                { text: 'order placed by', value: 'order_placed_by' },
                { text: 'Client Id', value: 'clientcode' },
                { text: 'Order /XSIP Number', value: 'order_number' },
                { text: 'ISIN', value: 'isin' },

                { text: 'Fund Name', value: 'scheme_name' },
                { text: 'Buy/Sell', value: 'buysell_type' },

                { text: 'Order Type', value: 'order_type' },
                { text: 'Amount', value: 'inv_lump_amt' },

                { text: 'Status', value: 'local_status' },
                // { text: '', value: 'staaction' },

            ],
            tabledataall: "",
            headersall: [
                {
                    text: 'Date & Time',
                    align: 'start',
                    value: 'date_time',
                },
                { text: 'Client Id', value: 'clientcode' },
                { text: 'Order /XSIP Number', value: 'ordernumber' },
                { text: 'ISIN', value: 'isin' },

                { text: 'Fund Name', value: 'schemename' },
                { text: 'Buy/Sell', value: 'buysell' },

                { text: 'Order Type', value: 'ordertype' },
                { text: 'Amount', value: 'amount' },

                { text: 'Status', value: 'orderstatus' },

            ],
            headersallred: [
                {
                    text: 'Date & Time',
                    align: 'start',
                    value: 'date_time',
                },
                { text: 'Client Id', value: 'clientcode' },
                { text: 'Order /XSIP Number', value: 'ordernumber' },
                { text: 'ISIN', value: 'isin' },

                { text: 'Fund Name', value: 'schemename' },
                { text: 'Buy/Sell', value: 'buysell' },

                { text: 'Order Type', value: 'ordertype' },
                { text: 'Amount', value: 'amount' },

                { text: 'Status', value: 'orderstatus' },
                { text: '', value: 'cancelord' },
               // { text: '', value: 'pausesip' },


            ],
            headersallmat: [
                {
                    text: 'Reg Date & Time',
                    align: 'start',
                    value: 'RegnDate',
                },
                {
                    text: 'Approved Date & Time',
                    align: 'start',
                    value: 'ApprovedDate',
                },
                { text: 'Client Id', value: 'ClientCode' },
                { text: 'Client Name', value: 'ClientName' },
                { text: 'Mandate Id', value: 'MandateId' },
                { text: 'Mandate Type', value: 'MandateType' },

                { text: 'Amount', value: 'Amount' },

                { text: 'Status', value: 'Status' },
                { text: '              ', value: 'linkman' },


            ],

            headersred: [
                {
                    text: 'Date',
                    align: 'start',
                    value: 'OrderDate',
                },
                { text: 'Client Id', value: 'ClientCode' },
                { text: 'Client Name', value: 'ClientName' },
                { text: 'Folio No', value: 'FolioNo' },
                { text: 'Order No', value: 'OrderNo' },

                { text: 'Order Type', value: 'OrderType' },
                // { text: 'Qty', value: 'Qty' },
                { text: 'Unit', value: 'Unit' },
                { text: 'Amount', value: 'Amt' },


                // { text: 'Status', value: 'Status' },
                // { text: '              ', value: 'linkman' },


            ],
            tableloadall: true,
            dispayadmindat: [],
            snackbar: false,
            snackmsgbar: "",
            snaclr: "#000",
            tableload: true,
            histtab: 8,
            alloredrdata: [],
            overlay: false,
            mf_mandates: [],
            message: '',
            mf_mandate: "",
            mdclientid: "",
            madcheckload: false,
            respondischeck: false,
            mangertresdata: [],
            urlcopyenable: false,
            mndteemtydat: "",
            createmat: false,
            creatManmfamt: 1000,
            creatManmffrommodel: "",
            creatManmffrommenu: false,

            creatManmftomodel: "",
            creatManmftomenu: false,
            creatManmRemarks: "",
            orderloader: false,
            orderpoploader: false,
            alertremarks: "",
            gemandlinkload: false,
            tablesearman: "",
            selectedmaid: "",
            redumstadata: [],
            redmsatse: "",
            redemload: true,
            sipclient: "",
            sipvalread: false,
            sipcliload: false,
            sipdataclilist: [],
            sipsearchlist: "",
            headersiplist: [
                 { text: "SIP Register Date", value: "SIPRegnDate", sortable: false },

        { text: "Start Date", value: "StartDate", sortable: false },
        { text: "End Date", value: "EndDate", sortable: false },
        { text: "Next SIP Date", value: "NextSIPDate", sortable: false },

        { text: "Fund name", value: "name", sortable: false },
        // { text: 'Type', value: 'AUM', sortable: false },
        { text: "", value: "action", sortable: false },
        { text: "Frequency Type", value: "FrequencyType", sortable: false },
        // {text: "Units", value: "Units", align: "right", sortable: false},
        { text: "Installment amt", value: "InstallmentAmount", align: "right", class: "ws-p", sortable: false },
        { text: "SIP Register No.", value: "SIPRegnNo", class: "ws-p", sortable: false },
        // {text: "Reason", value: "OrderRemarks", sortable: false},
        { text: "Status", value: "status", sortable: false },
                { text: '', value: 'cancelord' },
                { text: '', value: 'pausesip' },

            ],

            holdingheader: [
                { text: 'Client Id', value: 'CLIENTCODE' },
                { text: 'Client Name', value: 'CLIENT_NAME' },
                { text: 'Script Name', value: 'SCHEME_NAME' },
                { text: 'Units', value: 'NET' },
                { text: 'Min Redemption Qty', value: 'MINIMUM_REDEMPTION_QTY' },

                { text: 'Current NAV', value: 'nav' },

                { text: 'Invested', value: 'purchase' },
                { text: 'Current', value: 'current' },
                { text: 'Price', value: 'buy_price' },
                { text: 'Avg Price', value: 'bought' },
                { text: 'Abs Returns %', value: 'returnper' },

                { text: '', value: 'redmenbtn' },


            ],
            reinitload: false,
            paymentlinkcard: false,
            paymentres: [],
            cliholdlist: [],
            holdindcid: "",
            hlodvallist: false,
            holdingload: false,
            holdstadata: [],
            // snackmsgbar: "",
            redeamdia: false,
            redmetiondata: [],
            mf_redqty: "",
            redapicallload: false,
            sipnewArray: [],
            calceldiadet: [],
            dialogcancel: false,
            cancelresonlist: [],
            cancelresfd: "",
            cancelstload: false,
            // cancelresfd:"",
            canmanreason: "",
            finalloadcan: false,
            siporbookrest: "",
            cokkieload: false,
            // holdindcid:""
            tabledataallred: "",
            redmacationcancellist: [],
            dialogredcancel: false,
            candiashowdata: "",
            canredload: false,
            dispayadmindatnew: [],
            pausesipdet:[],
        pausesipinst:"",
        pauseconfirdia:false,
        mandatephysidet:[],
        mandatephydia : false
        }

    },
    methods: {
        cancelredfun(item) {
            this.candiashowdata = item
            this.dialogredcancel = true
        },
        redcancelapi() {
            this.canredload = true
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": this.candiashowdata.clientcode,
                "order_number": this.candiashowdata.ordernumber
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/lumsum_redemption_cancel',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.dialogredcancel = false
                    if (response.data.stat == 'Ok') {

                        axiosThis.holdindcid = ""
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = response.data.response_message;
                        axiosThis.allordersdata()

                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    axiosThis.canredload = false
                    axiosThis.dialogredcancel = false

                });

        },
        cokkegetapi() {
            this.cokkieload = true
            const axios = require('axios');
            let data = JSON.stringify({
                "cookie": this.holdindcid
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'http://192.168.5.175:5000/holdings_from_inv',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    axiosThis.cokkieload = false

                    // console.log(JSON.stringify(response.data));
                    if (response.data.stat == 'Ok') {

                        axiosThis.holdindcid = ""
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = response.data.msg;

                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.cokkieload = false
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    axiosThis.holdindcid = ""


                });

        },
        oderdeletedet(item) {
            this.calceldiadet = item
            this.cancelreason()
        },
               sippauseconfir(item){
this.pausesipdet = item
this.pauseconfirdia = true
        },
             pausesipapicall(){
            this.finalloadcan = true
            console.log("pausesipdet",this.pausesipdet);
            
const axios = require('axios');
let data = JSON.stringify({
  "ClientCode":  this.pausesipdet.ClientCode,
  "SIPRegnNo":  this.pausesipdet.SIPRegnNo,
  "installments":this.pausesipinst,
  "scheme_code":  this.pausesipdet.Scheme_Code,
           "placed_by": localStorage.getItem("clientid"),
    "source": `Partner Dasboard - ${localStorage.getItem("clientid")} - ${localStorage.getItem("email")}`,
});

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: 'https://v3.mynt.in/mfapi/order/xsip_pause',
  headers: { 
    'Content-Type': 'application/json'
  },
  data : data
};
            var axiosThis = this
axios.request(config)
.then((response) => {
//   console.log(JSON.stringify(response.data));
  axiosThis.finalloadcan = false
                    axiosThis.pauseconfirdia = false

                    if (response.data.stat == 'Ok') {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = response.data;
                        // axiosThis.allordersdata()
                        axiosThis.sipchekfun()

                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
})
.catch((error) => {
  console.log(error);
    axiosThis.finalloadcan = false
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    axiosThis.pauseconfirdia = false
});

        },
        cancelreason() {
            this.cancelstload = true
            const axios = require('axios');

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mfapi/order/reasons',
                headers: {}
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    axiosThis.cancelstload = false

                    // console.log(JSON.stringify(response.data));
                    if (response.data.stat == 'Ok') {

                        this.dialogcancel = true

                        axiosThis.cancelresonlist = response.data.data;

                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    console.log("else ");
                    axiosThis.cancelstload = false

                });

        },

        cancelapucall() {
                    this.finalloadcan = true
            const axios = require('axios');
            let data = JSON.stringify({
                "ClientCode": this.calceldiadet.ClientCode,
                "SIPRegnNo": this.calceldiadet.SIPRegnNo,
                "scheme_code": this.calceldiadet.Scheme_Code,
                "CaseNo": this.cancelresfd,
                  "placed_by": localStorage.getItem("clientid"),
    "source": `Partner Dasboard - ${localStorage.getItem("clientid")} - ${localStorage.getItem("email")}`,
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mfapi/order/xsip_cancel',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    axiosThis.finalloadcan = false
                    axiosThis.dialogcancel = false

                    if (response.data.stat == 'Ok') {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = response.data;
                        axiosThis.sipchekfun()
                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }

                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.finalloadcan = false
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    axiosThis.dialogcancel = false


                });

        },

        redamtionapi() {
            this.finalloadcan = true
            this.redapicallload = true
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": this.redmetiondata.CLIENTCODE,
                "scheme_code": this.redmetiondata.SCHEME_CODE,
                "buy_sell_type": "FRESH",
                "amount": "",
                "qty": this.mf_redqty,
                "all_redeem": "N"
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/lumsum_redemption',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    axiosThis.redeamdia = false
                    axiosThis.redapicallload = false
                    if (response.data.stat == 'Ok') {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = response.data.response_message;

                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.redeamdia = false
                    axiosThis.redapicallload = false
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                });

        },
        getclientholdlist() {
            this.holdingload = true
            this.cliholdlist = []
            this.holdstadata = []
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": this.holdindcid
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/GetHoldings_mob',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.holdingload = false

                    if (response.data.stat == 'Ok' && response.data.msg == "Data Found") {
                        axiosThis.cliholdlist = response.data.data
                        axiosThis.hlodvallist = true
                        // console.log("ifff");
                        axiosThis.holdstadata = response.data

                    }
                    else if (response.data.stat == 'Ok' && response.data.msg == "No Data Found") {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "orange";
                        axiosThis.snackmsgbar = response.data.msg;
                        console.log("else ifff");

                    }
                    else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "error";
                        axiosThis.snackmsgbar = response.data;
                        console.log("else ");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "error";
                    axiosThis.snackmsgbar = error;
                    axiosThis.holdingload = false

                });

        },
        clearholdindata() {

            this.holdindcid = ""
            this.cliholdlist = []
            this.holdstadata = []
            this.hlodvallist = false
        },
        redemcheck(item) {
            this.redeamdia = true
            this.redmetiondata = item
            this.mf_redqty = item.NET
        },
        reinitiateapicall(item) {
            this.reinitload = item.order_number
            console.log(item);
            this.reinipaylink = item
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": item.clientcode,
                "order_number": item.order_number
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/order_status_checking',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    if (response.data.stat == "Ok") {
                        if (response.data.server_resp == "100|PAYMENT NOT INITIATED FOR GIVEN ORDER") {
                            axiosThis.snackbar = true;
                            axiosThis.snaclr = "green";
                            axiosThis.snackmsgbar = "Payment Link Generated";
                            axiosThis.paymentlinkgen(item.clientcode)
                        } else {
                            axiosThis.reinitload = false
                            axiosThis.snackbar = true;
                            axiosThis.snaclr = "orange";
                            axiosThis.snackmsgbar = response.data.server_resp;
                        }
                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "red";
                        axiosThis.snackmsgbar = response.data;
                        axiosThis.reinitload = false

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "red";
                    axiosThis.snackmsgbar = error;
                    axiosThis.reinitload = false

                });


        },

        paymentlinkgen(ccode) {
            this.reinitload = true
            this.paymentres = []
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": ccode
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/payment_gateway_link',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.reinitload = false
                    if (response.data.stat == 'Ok') {
                        axiosThis.paymentres = response.data
                        axiosThis.paymentlinkcard = true
                        // axiosThis.snackbar = true;
                        // axiosThis.snaclr = "green";
                        // axiosThis.snackmsgbar = response.data;
                        // window.open(`${response.data.url}`, '_blank');
                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "green";
                        axiosThis.snackmsgbar = response.data;
                    }

                })
                // 
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snaclr = "red";
                    axiosThis.snackmsgbar = error
                    axiosThis.reinitload = false

                });

        },

        sipchekfun() {

            this.sipcliload = true
            const axios = require('axios');
            let data = JSON.stringify({
                "ClientCode": this.sipclient,
    "status":"ACTIVE"
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mfapi/order/FetchSIP',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.sipcliload = false

                    if (response.data.stat == "Ok") {
                        axiosThis.sipdataclilist = response.data.data
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = "SIP Details Listed"
                        axiosThis.snaclr = "green"
                        axiosThis.sipvalread = true


                    }
                    else {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = response.data
                        axiosThis.snaclr = "error"
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.sipcliload = false
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"

                });

        },

        clearsipdata() {
            this.sipvalread = false
            this.sipclient = ""
            this.sipdataclilist = []
        },


        redmenstatment() {
            this.redemload = true
            this.redumstadata = []
            const axios = require('axios');
            let data = JSON.stringify({
                "from_date": this.datestb3[0],
                "to_date": this.datestb3[1]
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/redemption_statement',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    //   console.log(JSON.stringify(response.data));
                    axiosThis.redemload = false

                    if (response.data.stat == "Ok") {
                        axiosThis.redumstadata = response.data

                    } else {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = response.data
                        axiosThis.snaclr = "error"
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"
                    axiosThis.redemload = false

                });

        },
        downloadFilesat() {
            const fileUrl = this.redumstadata.filepath
            window.open('https://v3.mynt.in/mf' + fileUrl, '_blank');
        },

        setDefaultmandate() {
            this.creatManmffrommodel = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).toISOString().slice(0, 10);
            this.creatManmftomodel = new Date(new Date().getFullYear() + 30, new Date(this.creatManmffrommodel).getMonth(), new Date().getDate()).toISOString().slice(0, 10);
        },
        createmandaute() {
            if (this.creatManmfamt >= 100) {
                this.orderloader = true
                const axios = require('axios');
                let data = JSON.stringify({
                    "client_code": this.mdclientid,
                    "amount": String(this.creatManmfamt),
                    "startdate": this.creatManmffrom,
                    "enddate": this.creatManmfto
                });

                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: 'https://v3.mynt.in/mf/mandate_creation',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data
                };
                var axiosThis = this
                axios.request(config)
                    .then((response) => {
                        // console.log(JSON.stringify(response.data));
                        axiosThis.createmat = false
                        this.orderloader = false
                        if (response.data.stat == "Ok") {
                            axiosThis.snackbar = true;
                            axiosThis.snaclr = "green";
                            axiosThis.snackmsgbar = 'Mandate registration done successfully';
                            axiosThis.clientmaddet()
                        } else {
                            axiosThis.snackbar = true;
                            axiosThis.snaclr = "red";
                            axiosThis.snackmsgbar = response.data;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        axiosThis.createmat = false
                        this.orderloader = false
                        axiosThis.snackbar = true;
                        axiosThis.snaclr = "red";
                        axiosThis.snackmsgbar = 'Network Error';
                    });
            } else {
                this.snackbar = true;
                this.snaclr = "red";
                this.snackmsgbar = 'The minimum amount required to create a mandate is ₹100.';
            }


        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        urlcopfun() {

            const url = this.mangertresdata.url;
            navigator.clipboard.writeText(url)
                .then(() => {
                    this.snackbar = true;
                    this.snaclr = "green";
                    this.snackmsgbar = "URL copied to clipboard!"
                    console.log('URL copied to clipboard!');
                    // You can also show a toast or snackbar here
                })
                .catch((err) => {
                    console.error('Failed to copy:', err);
                    this.snackbar = true;
                    this.snaclr = "red";
                    this.snackmsgbar = "Failed to copy Url"
                });


        },
        cleardata() {
            this.mdclientid = ""
            this.mf_mandates = [];
            this.mf_mandate = null;
            this.respondischeck = false
            this.mangertresdata = []
            this.mndteemtydat = ""

        },

        clientmaddet() {
            this.madcheckload = true
            this.mf_mandates = [];
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": this.mdclientid,
                "mandate_id": "",
                "from_date": "01/01/1900",
                "to_date": `31/12/${new Date().getFullYear()}`
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/mandate_details',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    var mandate = response.data
                    axiosThis.madcheckload = false
                    axiosThis.mndteemtydat = response.data
                    if (mandate.stat == "Ok") {
                        axiosThis.respondischeck = true
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = "Mandate Details Listed"
                        axiosThis.snaclr = "green"
                        axiosThis.mf_mandates = mandate.data.MandateDetails;
                        axiosThis.mf_mandate = mandate.data.MandateDetails[0];
                    } else if (mandate.error == 'Mandate Details Not Found') {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = "There are no mandates available, so please create one."
                        axiosThis.snaclr = "orange"
                    }
                    else {
                        axiosThis.mf_mandates = [];
                        axiosThis.mf_mandate = null;
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = mandate.error
                        axiosThis.snaclr = "error"
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"
                    axiosThis.madcheckload = false

                });

        },

        mandatelinkgenfun(status, manid) {
            if (status != 'REJECTED' && status != 'APPROVED') {
                this.selectedmaid = manid
                this.gemandlinkload = manid
                this.mangertresdata = []
                const axios = require('axios');
                let data = JSON.stringify({
                    "client_code": this.mdclientid,
                    "mandate_id": manid
                });

                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: 'https://v3.mynt.in/mf/e_mandate',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data
                };
                var axiosThis = this
                axios.request(config)
                    .then((response) => {
                        // console.log(JSON.stringify(response.data));
                        axiosThis.gemandlinkload = false

                        if (response.data.stat == "Ok") {
                            axiosThis.mangertresdata = response.data
                            axiosThis.snackbar = true
                            axiosThis.snackmsgbar = "Mandates  Link Generated"
                            axiosThis.snaclr = "green"
                            // axiosThis.urlcopyenable = true

                        } else {
                            axiosThis.snackbar = true
                            axiosThis.snackmsgbar = response.data.error
                            axiosThis.snaclr = "error"
                            axiosThis.gemandlinkload = false

                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = error
                        axiosThis.snaclr = "error"
                        axiosThis.gemandlinkload = false

                    });
            } else {
                this.snackbar = true
                this.snackmsgbar = `${status == 'APPROVED' ? "Your Mandate is Already Approved" : "Your Mandate is Rejected So Please Create a New Mandate"}`
                this.snaclr = "error"
            }
        },

        lumsunresdata() {
            this.tableload = true
            this.dispayadmindat = []
            this.dispayadmindatnew = []
            const axios = require('axios');
            let data = JSON.stringify({
                "from_date": this.dates[0],
                "to_date": this.dates[1],
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/mf_orders_dashboards',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    axiosThis.tableload = false
                    // console.log(JSON.stringify(response.data));
                    // // axiosThis.dispayadmindat = response.data
                    // axiosThis.dispayadmindatnew = response.data;
                    // console.log("typeof data:", typeof axiosThis.dispayadmindatnew);

                    // let jsonData = axiosThis.dispayadmindatnew;

                    // try {
                    //     // Optional deep replace of NaN/undefined with null
                    //     const sanitized = JSON.parse(JSON.stringify(jsonData, (key, value) => {
                    //         if (typeof value === "number" && isNaN(value)) return null;
                    //         if (typeof value === "undefined") return null;
                    //         return value;
                    //     }));

                    //     console.log("Converted JSON:", sanitized);
                    //     axiosThis.dispayadmindat = sanitized;
                    // } catch (error) {
                    //     console.error("Error during sanitizing:", error);
                    // }
                    if (response.data.stat == "Ok") {
                        axiosThis.dispayadmindat = response.data.data

                    } else {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = response.data
                        axiosThis.snaclr = "error"
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.tableload = false
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"
                });

        },
        closeMenu() {
            if (this.dates.length === 2) {
                console.log("Selected Dates:", this.dates);
                this.lumsunresdata()
                this.menu = false; // Close date picker after selection
            }
        },
        closeMenutb1() {
            if (this.datestb1.length === 2) {
                console.log("Selected Dates:", this.dates);
                this.allordersdata()
                this.menutb1 = false; // Close date picker after selection
            }
        },
        redustadate() {
            if (this.datestb3.length === 2) {
                console.log("Selected Dates:", this.dates);
                this.redmenstatment()
                this.menutb3 = false; // Close date picker after selection
            }
        },
        unpledgeregdown() {
            let rows = [];
            for (let t = 0; t < this.dispayadmindat.length; t++) {
                const element = this.dispayadmindat[t];
                rows.push({
                    "Date & Time": element.date_time,
                    "order placed by": element.order_placed_by,
                    "Client Id": element.clientcode,
                    "Order Number": element.order_number,
                    "Order No": element.order_number,
                    "ISIN":
                        element.isin,
                    "Fund Name": element.scheme_name,
                    "Order Type": element.order_type == "NRM" ? "One-Time" : element.order_type == "XSP" ? "SIP" : element.order_type,
                    "Status": element.local_status


                });
            }
            const exportType = exportFromJSON.types.csv;

            exportFromJSON({
                data: rows,
                fileName: `mfadmin_data` + this.dates,
                exportType: exportType,
            });
        },
        unpledgeregdownall() {
            let rows = [];
            for (let t = 0; t < this.alloredrdata.length; t++) {
                const element = this.alloredrdata[t];
                rows.push({
                    "Date & Time": element.date_time,
                    "Client Id": element.clientcode,
                    "Order Number": element.ordernumber,

                    "sipregnno": element.sipregnno,
                    "ISIN":
                        element.isin,
                    "Fund Name": element.schemename,
                    "Order Type": element.ordertype == "NRM" ? "One-Time" : element.ordertype == "XSP" ? "SIP" : element.ordertype,
                    "Amount": element.amount,

                    "Status": element.local_status,
                    "orderremarks": element.orderremarks



                });
            }
            const exportType = exportFromJSON.types.csv;

            exportFromJSON({
                data: rows,
                fileName: `mfadmin_data` + this.datestb1,
                exportType: exportType,
            });
        },
        allordersdata() {
            this.sipnewArray = []
            this.redmacationcancellist = []


            this.tableloadall = true
            this.alloredrdata = []
            const axios = require('axios');
            let data = JSON.stringify({
                "from_date": this.datestb1[0],
                "to_date": this.datestb1[1]
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/mf_admin_orderbook',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    if (response.data.stat == "Ok") {
                        axiosThis.alloredrdata = response.data.data
                        axiosThis.tableloadall = false
                        for (let index = 0; index < axiosThis.alloredrdata.length; index++) {
                            const element = response.data.data[index];
                            if (element.ordertype === 'XSP') {
                                axiosThis.sipnewArray.push(element);
                            }
                            if (element.ordertype === 'NRM') {
                                axiosThis.redmacationcancellist.push(element);
                            }
                        }
                        console.log("axiosThis.sipnewArray", axiosThis.sipnewArray);


                    } else {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = response.data
                        axiosThis.snaclr = "error"
                        axiosThis.tableloadall = false

                    }
                    //   axiosThis.alloredrdata = response.data.data
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"
                    axiosThis.tableloadall = false

                });

        },
        logout() {
            this.overlay = true;

            setTimeout(() => {
                localStorage.clear();

                window.location.assign("/mflogin");
                // localStorage.clear();
            }, 1000);

            // window.location.reload();
            // this.$router.push("/");
        },
    },
    computed: {
        dateRangeText() {
            return this.dates.join(" ~ ");
        },
        dateRangeTexttb1() {
            return this.datestb1.join(" ~ ");
        },
        dateRangeTexttb3() {
            return this.datestb3.join(" ~ ");
        },
        creatManmffrom() {
            return this.formatDate(this.creatManmffrommodel);
        },

        creatManmfto() {
            return this.formatDate(this.creatManmftomodel);
        },
    },
    mounted() {
        // this.lumsunresdata()
        // this.allordersdata()
        // this.redmenstatment()
        this.first = localStorage.getItem("emailmf");
        this.siporbookrest = this.$route.query.sip

        console.log("siiii", this.siporbookrest);

        //  console.log(" this.first", this.first);

        // if (this.first == null) {
        //  this.$router.push("/mflogin");
        // }
    }
}
</script>